import { render, staticRenderFns } from "./BrokersTable.container.vue?vue&type=template&id=b4f884a8&scoped=true&"
import script from "./BrokersTable.container.vue?vue&type=script&lang=js&"
export * from "./BrokersTable.container.vue?vue&type=script&lang=js&"
import style0 from "./BrokersTable.container.vue?vue&type=style&index=0&id=b4f884a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f884a8",
  null
  
)

export default component.exports